/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FormAuditUpdateDto } from '../../models/form-audit-update-dto';
import { FormAuditUpdateResponseDto } from '../../models/form-audit-update-response-dto';

export interface UpdateFormAudit$Params {
  formId: string;
  body: FormAuditUpdateDto;
}

export function updateFormAudit(
  http: HttpClient,
  rootUrl: string,
  params: UpdateFormAudit$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<FormAuditUpdateResponseDto>> {
  const rb = new RequestBuilder(rootUrl, updateFormAudit.PATH, 'put');
  if (params) {
    rb.path('formId', params.formId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FormAuditUpdateResponseDto>;
    })
  );
}

updateFormAudit.PATH = '/auditing/forms/{formId}';
